import * as react from "react";

export const globalContext = react.createContext();